<template>
    <div v-if="planNickname.toLowerCase().includes('platinum')">
        <img max-width="300em;" src="../assets/platinum.png" />
        <p>Customizable</p>
        <p>Customizable</p>
        <p>Customizable</p>
        <p>Unlimited Access to Managing Artworks</p>
        <p>Unlimited Event Calendar</p>
        <p>Unlimited Access to Reports</p>
    </div>

    <div v-else-if="planNickname.toLowerCase().includes('gold')">
        <img max-width="300em;" src="../assets/gold.png" />
        <p>Verify Up to 250 Artworks With Image</p>
        <p>Send 6 Event Notifications Monthly</p>
        <p>Reach Up to 10,000 Users Per Notification</p>
        <p>Unlimited Access to Managing Artworks</p>
        <p>Unlimited Event Calendar</p>
        <p>Unlimited Access to Reports</p>
    </div>

    <div v-else-if="planNickname.toLowerCase().includes('silver')">
        <img max-width="300em;" src="../assets/silver.png" />
        <p>Verify Up to 80 Artworks With Image</p>
        <p>Send 3 Event Notifications Monthly</p>
        <p>Reach Up to 5,000 Users Per Notification</p>
        <p>Unlimited Access to Managing Artworks</p>
        <p>Unlimited Event Calendar</p>
        <p>Unlimited Access to Reports</p>
    </div>

    <div v-else>
        <img max-width="300em;" src="../assets/bronze.png" />
        <p>Verify Up to 25 Artworks With Image</p>
        <p>Send 1 Event Notification Monthly</p>
        <p>Reach Up to 2,000 Users Per Notification</p>
        <p>Unlimited Access to Managing Artworks</p>
        <p>Unlimited Event Calendar</p>
        <p>Unlimited Access to Reports</p>
    </div>
</template>

<script>
    export default {
        name: 'SubscriptionDetails',
        props: {
            planNickname: String
        }
    }
</script>